import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import axios from "../utils/axios";

import { SocketContext } from "../contexts/SocketContext";
import { GAME_STATE_REVEALING_CARDS, GAME_STATE_ALL_CARDS_CHOOSEN } from "../contexts/constants";

import Table from "../components/Table";
import CardSelectionModule from "../components/CardSelectionModule";
import Button from "../components/Button";
import CardValuesAgreement from "../components/CardValuesAgreement";
import Card from "../components/Card";
import Result from "../components/Result";

import { cardStyles } from "../components/cardStyles";
import ShareARoom from "../components/ShareARoom";
// import AssigneeSlotMachine from "../components/AssigneeSlotMachine";
import { AuthContext } from "../contexts/AuthContext";

function Room(){
  const {
    socket,
    createSocket,
    isHost,
    revealCards,
    startNewRound,
    gameState,
    averageScore,
    // valuesAgreement,
    maxPercentage,
    counting,
    setCardStyle,
    cardStyle,
    resetData
  } = useContext(SocketContext);
  const { username, isLoggedIn, verifyToken } = useContext(AuthContext);
  const { id } = useParams();
  
  const [roomEntered, setRoomEntered] = useState(false);
  const [usernames, setUsernames] = useState([]);
  const [usernameInput, setUsernameInput] = useState(username);
  const [userCardStyles, setUserCardStyles] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    // when going to room directly via url, create socket for yourself and join room with id 
    if (!socket) {
      createSocket(id);
    } else {
      socket.on("usernames",function(data){
        setUsernames(data);
      });
    }
  }, [socket, id, createSocket]);

  useEffect(() => {
    if (isLoggedIn) {
      fetchImages();
    }

    return () => resetData();
  }, [isLoggedIn]);

  const handleUsername = (e) => {
    socket.emit("new user", { username: usernameInput, roomId: id, cardValue: null, cardStyle, verifyToken }, function (data) {
    });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!usernameInput) {
      setError("Username cannot be empty");
      return;
    }
    if (!cardStyle) {
      const rand = Math.floor(Math.random() * (cardStyles.length - 1) + 1);
      setCardStyle(cardStyles[rand]);
    }
    setRoomEntered(true);
    handleUsername();
  };

  const handleUsernameInput = (e) => {
    setUsernameInput(e.target.value);
    setError(null);
  };

  const handleReveal = () => {
    if (canReveal){
      revealCards();
    }
  };

  const handleNewRound = () => {
    if (isReveal){
      startNewRound();
    }
  };

  const fetchImages = async () => {
    try {
      const response = await axios.get("/images/gallery");
      setUserCardStyles(response.data.cardStyles);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    }
  };

  const isReveal = gameState === GAME_STATE_REVEALING_CARDS;
  const canReveal = gameState === GAME_STATE_ALL_CARDS_CHOOSEN;
  
  if (!roomEntered){
    return (
      <div className="room">
        <Helmet>
          <title>Room | Poker Planning</title>
          <meta name="description" content="Collaborate with your team in real-time to estimate tickets using planning cards. Keep your sprints sharp and your team in sync." />
          <meta property="og:title" content="Room | Poker Planning" />
        </Helmet>
        <div className="username-selector">
          <form onSubmit={handleSubmit}>
            <div>
              <label>Username</label>
              <input type="text" placeholder="Type username" className="text-input" onChange={handleUsernameInput} defaultValue={username}></input>
              {error && <label className="error">{error}</label>}
            </div>
            <label>Select Card Style</label>
            <div className="card-style-selector">
              {userCardStyles.map(item => (
                <div className={`card display chosen ${item._id === cardStyle ? "card-style-selected" : ""}`} key={item._id} onClick={() => setCardStyle(item._id)} style={{
                  backgroundImage: `url(${item.url})`,
                  backgroundRepeat: item.backgroundRepeat,
                  backgroundSize: item.backgroundSize + "%",
                  backgroundPositionX: item.backgroundPosition[0] + "%",
                  backgroundPositionY: item.backgroundPosition[1] + "%",
                  animation: item.backgroundAnimation,
                  opacity: 1
                }}></div>
              ))}
              {cardStyles.map((card, i) => <Card key={`${i}card`} cardStyleSelected={card === cardStyle} cardValue={true} onClick={() => setCardStyle(card)} cardStyles={card} />)}
            </div>  
            <input className="button host-buttons card-style-button" type="submit"></input>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="room">
      <Table isReveal={isReveal} usernames={usernames}></Table>
      <ShareARoom />
      {isHost && <Button title="Reveal cards after all are choosen" className={`button host-buttons reveal-cards ${canReveal ? "" : "inactive" }`} onClick={handleReveal}> Reveal Cards</Button>}
      {isHost && <Button className={`button host-buttons new-round ${isReveal ? "" : "inactive"}`} onClick={handleNewRound}>New round</Button>}
      <CardSelectionModule />
      {isReveal && !counting && <CardValuesAgreement maxPercentage={maxPercentage}/>}
      <Result value={maxPercentage} average={averageScore}/>
      {/* <AssigneeSlotMachine /> */}
    </div>
  );
}

export default Room;
